const Vue = require('vue')
import apihelper from './apihelper'
import config from '@/util/config'

export default {
    gethome() {
        return apihelper.get("/menu/gethome");
    }
}